<template>
  <v-app>
    <div class="wrapper" id="app">
      <div class="card-form">
        <div style="text-align: center;" class="mb-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150px"
            fill="#fff"
            viewBox="0 0 210.31 32.08"
          >
            <g id="Camada_2" data-name="Camada 2">
              <g id="Camada_1-2" data-name="Camada 1">
                <path
                  d="M31.32 31.43h22.14v-7.17H40.92v-4.98h11.29v-7.17H40.92V7.83h12.54V.65H31.32v30.78zM75.92 22.09L69.91.65h-8.78l10.55 30.78h8.35L90.58.65h-8.61l-6.05 21.44zM98.61 31.43h20.42v-5.14h-13.91v-7.91h12.54v-5.15h-12.54V5.79h13.91V.65H98.61v30.78zM148.75 16a9.3 9.3 0 0 0 1.49-5.4v-1a11.36 11.36 0 0 0-.52-3.48 7.59 7.59 0 0 0-1.62-2.83 7.75 7.75 0 0 0-2.85-1.92A11.18 11.18 0 0 0 141 .65h-12.33v30.78H134V19.59h5.19l6.31 11.85h5.84L144.41 19a7.83 7.83 0 0 0 4.35-3m-5.21-1.9a5.65 5.65 0 0 1-3.81 1.12H134V5.06h6q4.89 0 4.89 4.8v.6a4.51 4.51 0 0 1-1.3 3.59M179.7 3.83A8.61 8.61 0 0 0 176 1a18.15 18.15 0 0 0-11.85 0 8.85 8.85 0 0 0-3.72 2.85 11.16 11.16 0 0 0-1.92 4.45 28.69 28.69 0 0 0-.54 5.84v3.8a30.23 30.23 0 0 0 .52 5.86 11.13 11.13 0 0 0 1.86 4.45 8.6 8.6 0 0 0 3.65 2.84 18.14 18.14 0 0 0 11.85 0 8.84 8.84 0 0 0 3.72-2.85 11.18 11.18 0 0 0 1.92-4.45 28.75 28.75 0 0 0 .54-5.84v-3.8a30.21 30.21 0 0 0-.52-5.86 11.14 11.14 0 0 0-1.86-4.45m-2 14.12a23.63 23.63 0 0 1-.48 5.23 7.85 7.85 0 0 1-1.43 3.2 4.94 4.94 0 0 1-2.35 1.61 12.75 12.75 0 0 1-6.74 0 4.93 4.93 0 0 1-2.38-1.62 7.63 7.63 0 0 1-1.4-3.2 24.69 24.69 0 0 1-.45-5.23v-3.8a23.7 23.7 0 0 1 .48-5.21 7.86 7.86 0 0 1 1.43-3.22 4.94 4.94 0 0 1 2.38-1.62 12.75 12.75 0 0 1 6.74 0 4.94 4.94 0 0 1 2.38 1.62 7.66 7.66 0 0 1 1.4 3.2 24.68 24.68 0 0 1 .45 5.23zM210 19.89a6.38 6.38 0 0 0-1.19-2.4 6.63 6.63 0 0 0-2.27-1.77 12.48 12.48 0 0 0-3.59-1.06l-4-.61a7.31 7.31 0 0 1-4.26-1.67 5 5 0 0 1-1.19-3.61 5.59 5.59 0 0 1 1.88-4.6q1.88-1.53 6.2-1.54a24.55 24.55 0 0 1 3.85.3 22.58 22.58 0 0 1 3.37.78l.61-2.21A19.91 19.91 0 0 0 206 .58a22.71 22.71 0 0 0-4.17-.37 17.67 17.67 0 0 0-4.54.54 10.34 10.34 0 0 0-3.46 1.58 6.89 6.89 0 0 0-2.18 2.59 8.12 8.12 0 0 0-.76 3.59v.22a7.9 7.9 0 0 0 1.66 5.34q1.66 1.92 5.56 2.49l3.89.56a11 11 0 0 1 2.83.76 4.52 4.52 0 0 1 1.71 1.25 4.44 4.44 0 0 1 .84 1.71 8.39 8.39 0 0 1 .24 2q0 3.42-1.88 5t-6.33 1.58a24.56 24.56 0 0 1-4.37-.37 36.88 36.88 0 0 1-3.67-.84l-.52 2.29a22.63 22.63 0 0 0 3.85 1 27.53 27.53 0 0 0 4.63.39 17 17 0 0 0 4.89-.63 9.56 9.56 0 0 0 3.44-1.77 7.21 7.21 0 0 0 2-2.72 8.83 8.83 0 0 0 .67-3.48v-.52a11.42 11.42 0 0 0-.35-2.85M11.13.65H0v30.78h21.62v-8.31H11.13V.65z"
                  class="logo-leveros-svg"
                ></path>
              </g>
            </g>
          </svg>
          <!-- <div class="white--text ma-5 text-h2 font-weight-bold" style="text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; font-family: Source Sans Pro, sans-serif;">
            {{ ValorRestantePagamento | toCurrency }}
          </div> -->
        </div>
        <div class="card-list">
          <div class="card-item" v-bind:class="{ '-active' : isCardFlipped }">
            <div class="card-item__side -front">
              <div class="card-item__focus" v-bind:class="{'-active' : focusElementStyle }" v-bind:style="focusElementStyle" ref="focusElement"></div>
              <div class="card-item__cover">
                <img :src="getImageJPEG(currentCardBackground)" class="card-item__bg">
              </div>
              
              <div class="card-item__wrapper">
                <div class="card-item__top">
                  <img src="../assets/images/chip.png" class="card-item__chip">
                  <div class="card-item__type">
                    <transition name="slide-fade-up">
                      <img v-bind:src="getImagePNG(getCardType)" v-if="getCardType" v-bind:key="getCardType" alt="" class="card-item__typeImg">
                    </transition>
                  </div>
                </div>
                <label for="cardNumber" class="card-item__number" ref="cardNumber">
                  <template v-if="getCardType === 'amex'">
                  <span v-for="(n, $index) in amexCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''"
                      >*</div>
                      <div class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        :key="$index" v-else-if="cardNumber.length > $index">
                        {{cardNumber[$index]}}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >{{n}}</div>
                    </transition>
                  </span>
                  </template>

                  <template v-else>
                    <span v-for="(n, $index) in otherCardMask" :key="$index">
                      <transition name="slide-fade-up">
                        <div
                          class="card-item__numberItem"
                          v-if="$index > 4 && $index < 15 && cardNumber.length > $index && n.trim() !== ''"
                        >*</div>
                        <div class="card-item__numberItem"
                          :class="{ '-active' : n.trim() === '' }"
                          :key="$index" v-else-if="cardNumber.length > $index">
                          {{cardNumber[$index]}}
                        </div>
                        <div
                          class="card-item__numberItem"
                          :class="{ '-active' : n.trim() === '' }"
                          v-else
                          :key="$index + 1"
                        >{{n}}</div>
                      </transition>
                    </span>
                  </template>
                </label>
                <div class="card-item__content">
                  <label for="cardName" class="card-item__info" ref="cardName">
                    <div class="card-item__holder">Nome</div>
                    <transition name="slide-fade-up">
                      <div class="card-item__name" v-if="cardName.length" key="1">
                        <transition-group name="slide-fade-right">
                          <div class="card-item__nameItem" v-for="(n, $index) in cardName.replace(/\s\s+/g, ' ')" v-bind:key="$index + 1">
                            <span  v-if="$index === $index">{{n}}</span>
                          </div>
                        </transition-group>
                      </div>
                      <div class="card-item__name" v-else key="2">Nome Completo</div>
                    </transition>
                  </label>
                  <div class="card-item__date" ref="cardDate">
                    <label for="cardMonth" class="card-item__dateTitle">Validade</label>
                    <label for="cardMonth" class="card-item__dateItem">
                      <transition name="slide-fade-up">
                        <span v-if="cardMonth" :key="cardMonth">{{cardMonth}}</span>
                        <span v-else key="2">MM</span>
                      </transition>
                    </label>
                    <label :class="!cardMonth ? 'ml-2' : true">/</label>
                    <label for="cardYear" class="card-item__dateItem">
                      <transition name="slide-fade-up">
                        <span v-if="cardYear" :key="cardYear">{{String(cardYear).slice(2,4)}}</span>
                        <span v-else key="2">AA</span>
                      </transition>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-item__side -back">
              <div class="card-item__cover">
                <img :src="getImageJPEG(currentCardBackground)" class="card-item__bg">
            </div>
              <div class="card-item__band"></div>
              <div class="card-item__cvv">
                  <div class="card-item__cvvTitle">CVV</div>
                  <div class="card-item__cvvBand">
                    <span v-for="(n, $index) in cardCvv" :key="$index">
                      *
                    </span>

                </div>
                  <div class="card-item__type">
                      <img :src="getImagePNG(getCardType)" v-if="getCardType" class="card-item__typeImg">
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-form__inner">
          <div class="card-input text-center">
            <label for="cardNumber" class="card-input__label" v-if="ValorRestantePagamento">Valor disponível para pagamento:</label>
            <label for="cardNumber" class="card-input__label" style="font-size: larger;">{{ ValorRestantePagamento | toCurrency }}</label>
          </div>
          <div class="card-input">
            <label for="cardNumber" class="card-input__label">Número do cartão</label>
            <input type="text" id="cardNumber" class="card-input__input" v-mask="generateCardNumberMask" v-model="cardNumber" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardNumber" autocomplete="off">
          </div>
          <div class="card-input">
            <label for="cardName" class="card-input__label">Nome impresso no cartão</label>
            <input type="text" id="cardName" class="card-input__input" style="text-transform: uppercase;" v-model="cardName" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardName" autocomplete="off">
          </div>
          <div class="card-input">
            <label for="cardNumber" class="card-input__label">CPF do titular</label>
            <input type="text" id="cardNumber" class="card-input__input" v-mask="cpfMask" v-model="cpfTitular" autocomplete="off">
          </div>
          <div class="card-form__row">
            <div class="card-form__col">
              <div class="card-form__group">
                <label for="cardMonth" class="card-input__label">Data de validade</label>
                <select class="card-input__input -select" id="cardMonth" v-model="cardMonth" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate">
                  <option :value="null" disabled selected>Mês</option>
                  <option :value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">
                      {{n &lt; 10 ? '0' + n : n}}
                  </option>
                </select>
                <select class="card-input__input -select" id="cardYear" v-model="cardYear" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate">
                  <option :value="null" disabled selected>Ano</option>
                  <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">
                      {{$index + minCardYear}}
                  </option>
                </select>
              </div>
            </div>
            <div class="card-form__col -cvv">
              <div class="card-input">
                <label for="cardCvv" class="card-input__label">CVV</label>
                <input type="text" class="card-input__input" id="cardCvv" v-mask="'####'" maxlength="4" v-model="cardCvv" v-on:focus="flipCard(true)" v-on:blur="flipCard(false)" autocomplete="off">
              </div>
            </div>
          </div>
          <div class="card-form__row">
            <div class="card-form__col">
              <div class="card-input">
                <label for="cardName" class="card-input__label">Quantidade de parcelas</label>
                <select class="card-input__input -select" v-model="parcelasSelecionada">
                  <option :value="null" disabled selected>Selecione</option>
                  <option :value="n < 10 ? '0' + n : n" v-for="n in 12" :key="n">
                      {{n &lt; 10 ? n : n}} x
                  </option>
                </select>
              </div>
            </div>
            <div class="card-form__col">
              <div class="card-input">
                <label for="cardName" class="card-input__label">Valor a ser pago</label>
                <money type="text" id="cardName" v-bind="money" class="card-input__input" v-model="valorPagamento"  @blur.native="blurValidaValor()" autocomplete="off"></money>
              </div>
            </div>
          </div>

          <button class="card-form__button" :disabled="ValorRestantePagamento === 0" @click="finalizaPagamento()">FINALIZAR PAGAMENTO</button>
        </div>
      </div>
      <!-- Itens do pedido -->
      <div v-if="Pedido">
        <v-card class="mt-10 pa-5" no-gutters>
          <div class="">
            <div class="text-h5 text-center  font-weight-bold mb-4" style="color: var(--standardGreen);">Pedido: {{Pedido.NRPedido}}</div>
          </div>
          <v-divider class="mb-5"></v-divider>
          <div class="d-flex flex-wrap flex-row justify-space-around mt-5">
            <div style="width: 290px;" class="mb-5">
              <div class="text-h5 text-center  font-weight-bold mb-4" style="color: var(--standardGreen);">Totais:</div>
              <v-divider></v-divider>
              <div class="text-h5 text-center font-weight-bold">{{ (Pedido.vlliquido + Pedido.vltotalfrete) | toCurrency }}</div>
              <v-divider></v-divider>
              <div class="justify-center d-flex flex-wrap">
                <div class="text-left mr-4">
                  <div class="text-h6">Valor Bruto:</div>
                  <div class="text-h6">Descontos:</div>
                  <div class="text-h6">Valor Líquido:</div>
                  <div class="text-h6">Valor do Frete:</div>
                  <div class="text-h6">Valor Total:</div>
                </div>
                <div class="text-left">
                  <div class="text-h6">{{ Pedido.vlBruto | toCurrency }}</div>
                  <div class="text-h6">{{ Pedido.vlDesconto | toCurrency }}</div>
                  <div class="text-h6">{{ Pedido.vlliquido | toCurrency }}</div>
                  <div class="text-h6">{{ Pedido.vltotalfrete | toCurrency }}</div>
                  <div class="text-h6">{{ (Pedido.vlliquido + Pedido.vltotalfrete) | toCurrency }}</div>
                </div>
              </div>
            </div>
            <!-- Exibe se houver outros pagamentos -->
            <div style="width: 290px;" class="mb-5" v-if="Pedido.pagamentosRealizados && Pedido.pagamentosRealizados.length > 0">
              <div class="text-h5 font-weight-bold mb-4 text-center" style="color: var(--standardGreen);">Pagamentos Realizados:</div>
              <v-list dense>
                <v-list-item-group color="#005a64">
                  <v-list-item style="padding: 0 !important;" v-for="(n, $index) in Pedido.pagamentosRealizados" :key="$index">
                    <v-list-item-icon>
                      <v-icon>mdi-currency-usd</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ n.parcelas }}x de {{ n.valorPago | toCurrency }} {{ moment(n.data).format("DD/MM/YYYY") }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon v-if="n.dtbaixa && n.usuarioAprovacao">
                      <v-icon color="green">mdi-check</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div>
                <div class="text-h6 text-center">Valor Pago: {{ TotalPago | toCurrency }}</div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="pa-5">
            <div class="text-h5 font-weight-bold mt-4" style="color: var(--standardGreen);">Itens do Pedido:</div>
            <div class="order">
              <div class="products">
                <div v-for="(info, i) in Pedido.cjPedido" :key="i" >
                  <div class="item">
                    <div class="item__image">
                      <img :src="info.linkimagem" :alt="info.dsConjunto" />
                    </div>
                    <div class="item__description font-weight-medium">
                      <div class="text-subtitle-2">{{ info.dsConjunto }}</div>
                      <div class="text-subtitle-2">Quantidade: {{ info.qtd }}</div>
                      <div class="text-subtitle-2">Valor: {{ info.VlLiquido | toCurrency }}</div>
                    </div>
                  </div>
                  <v-divider v-if="i < (Pedido.cjPedido.length - 1)"></v-divider>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <!-- Dialogos -->
    <!-- Loading -->
    <v-dialog v-model="loading.active" persistent width="300">
      <v-card color="var(--standardGreen)" dark>
        <v-card-text style="padding: 27px">
          <div v-html="loading.message"></div>
          <v-progress-linear
            style="margin-top: 15px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Erro -->
    <v-dialog v-model="errorDialog.active" persistent width="400">
      <v-card>
        <v-card-title class="text-h5" style="background: #005a64; color: white;">Ops...</v-card-title>
        <div class="pa-7" v-html="errorDialog.message"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#005a64" text @click="errorDialog.action">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Error Persist -->
    <v-dialog v-model="errorPersistDialog.active" persistent width="400">
      <v-card>
        <v-card-title class="text-h5" style="background: #005a64; color: white;">Ops...</v-card-title>
        <div class="pa-7" v-html="errorPersistDialog.message"></div>
      </v-card>
    </v-dialog>
    <!-- Pagamento realizado -->
    <v-dialog v-model="successDialog.active" persistent width="400">
      <v-card>
        <v-card-title class="text-h5" style="background: #005a64; color: white;">Sucesso!</v-card-title>
        <div class="pa-7" v-html="successDialog.message"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#005a64" text @click="window.location.reload()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { Money } from "v-money";

export default {
  data() {
    return {
      baseURL: 'https://www.leverosintegra.com.br/MAP/api',
      currentCardBackground: Math.floor(Math.random()* 25 + 1), // just for fun :D
      cardName: "",
      cardNumber: "",
      cardMonth: null,
      cardYear: null,
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cpfMask: "###.###.###-##",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      loading:{
        active: false,
        message: null
      },
      errorDialog: {
        active: false,
        message: null,
        action: null
      },
      errorPersistDialog: {
        active: false,
        message: null
      },
      successDialog: {
        active: false,
        message: null
      },
      Pedido: null,
      parcelasSelecionada: null,
      valorPagamento: '',
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      ValorTotalPedido: null,
      cpfTitular: null,
      codigoBandeiraYapay: null,
      TotalPago: 0,
      ValorRestantePagamento: null,
      window: window,
      cartaoValido: null
    }
  },

  components: {
    Money
  },

  mounted() {
    this.cardNumberTemp = this.otherCardMask;
    document.getElementById("cardNumber").focus();

    // Inicializa script da Yapay
    let yapayScript = document.createElement('script')
    yapayScript.setAttribute('src', 'https://static.traycheckout.com.br/js/finger_print.js')
    document.head.appendChild(yapayScript)
  },

  created() {

    // Recupera o número do pedido
    const order = this.$route.query.Order;
    this.loading.message = "Buscando dados do pedido. Aguarde...";
    this.loading.active = true;

    axios.get(`${this.baseURL}/newyapay?idpedido=${order}&newYapay=true`)
    .then(res => {
      // Recupera os dados do pedido
      let pedidoTemp = res.data[0];

      // Trata erros / validações da API
      if (pedidoTemp.statusRetorno === 'err') {
        this.errorPersistDialog.message = pedidoTemp.observacao;
        this.errorPersistDialog.active = true;
        return;
      }

      // Recupera IP do Usuário
      axios.get(`${this.baseURL}/ip`)
      .then((res) => {
        // Recupera o IP do usuário
        this.ip = res.data[0];

        // Inicializa fingerPrint (Yapay)
        window.yapay.FingerPrint({ env: 'sandbox' }).getFingerPrint();

        // Recupera dados do pedido
        this.Pedido = pedidoTemp;
        
        // Tratativa de itens solar
        if (this.Pedido.orderConfigs) {
          this.Pedido.orderConfigs.forEach(i => {
            let item = {
              linkimagem: i.urlImagem,
              dsConjunto: i.dsproduto,
              qtd: i.quantidade,
              VlLiquido: (i.yven - i.ydes)
            };
            this.Pedido.cjPedido.push(item);
          });
        }

        if (this.Pedido.frmPagamento) {
          this.Pedido.pagamentosRealizados = [];
          this.Pedido.frmPagamento.forEach(i => {
            let item = {
              valorPago: i.vlTotal,
              parcelas: i.nrparcela,
              data: i.dtbaixa,
              dtbaixa: i.dtbaixa ? i.dtbaixa : null,
              usuarioAprovacao: i.usuarioaprovacao ? i.usuarioaprovacao : null
            }
            // Calcula o total de valor já pago
            this.TotalPago += i.vlTotal
            this.Pedido.pagamentosRealizados.push(item);
          })
        }

        this.ValorTotalPedido = parseFloat((this.Pedido.vlliquido + this.Pedido.vltotalfrete).toPrecision(12))

        this.ValorRestantePagamento = this.ValorTotalPedido - (this.TotalPago ? this.TotalPago : 0);
        this.loading.active = false;

      }).catch(err => {
        console.log(err.message)
        this.errorPersistDialog.message = "Erro ao buscar IP do usuário";
        this.errorPersistDialog.active = true;
        return;
      })
    }).catch(err => {
      console.log(err)
      this.errorPersistDialog.message = "Erro ao buscar dados: <br/>" + err;
      this.errorPersistDialog.active = true;
      return;
    })

  },

  computed: {
    getCardType () {
      // Remove espaços da string
      let number = this.cardNumber.replace(/\s/g, '');

      // Valida Visa
      let visa = /^4[0-9]{12}(?:[0-9]{3})/;
      if (visa.test(number)) {
        this.atualizaCodigoBandeiraYapay(3);
        return "visa";
      }

      // Valida Mastercard
      let master = /^5[1-5][0-9]{14}/;
      if (master.test(number)) {
        this.atualizaCodigoBandeiraYapay(4);
        return "mastercard";
      }

      let master2 = /^2[1-5][0-9]{14}/;
      if (master2.test(number)) {
        this.atualizaCodigoBandeiraYapay(4);
        return "mastercard";
      }

      // Valida amex
      let amex = /^3[47][0-9]{13}/;
      if (amex.test(number)) {
        this.atualizaCodigoBandeiraYapay(5);
        return "amex";
      }

      // Valida Hiper
      let hiper = /^(606282\d{10}(\d{3})?)|(3841\d{15})/;
      if (hiper.test(number)) {
        this.atualizaCodigoBandeiraYapay(20);
        return "hiper";
      }
      
      // Valida Elo
      let elo = /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/;
      if (elo.test(number)) {
        this.atualizaCodigoBandeiraYapay(16);
        return "elo";
      }

      return this.cartaoInvalido();
    },

    generateCardNumberMask () {
      return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },

    minCardMonth () {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    }
  },

  watch: {
    cardYear () {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = null;
      }
    }
  },

  methods: {
    cartaoInvalido() {
      this.cartaoValido = false;
      return "visa";
    },

    atualizaCodigoBandeiraYapay(cod) {
      this.cartaoValido = true;
      this.codigoBandeiraYapay = cod;
    },

    getImageJPEG(image) {
      let images = require.context('../assets/images/', false, /\.jpeg$/)
      return images('./' + image + ".jpeg")
    },

    getImagePNG(image) {
      let images = require.context('../assets/images/', false, /\.png$/)
      return images('./' + image + ".png")
    },

    flipCard(status) {
      this.isCardFlipped = status;
    },

    focusInput(e) {
      this.isInputFocused = true;
      let targetRef = e.target.dataset.ref;
      let target = this.$refs[targetRef];
      this.focusElementStyle = {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      }
    },

    blurInput() {
      let vm = this;
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null;
        }
      }, 300);
      vm.isInputFocused = false;
    },

    blurValidaValor() {
      this.validacoes(true);
    },

    validacoes(validaValor = false) {

      if (!validaValor) {
        // Valida número de cartão
        if (!this.cardNumber) {
          this.errorDialog.message = "Número do cartão não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        if (!this.cartaoValido) {
          this.errorDialog.message = "Número do cartão inválido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        // Valida nome do cartão
        if (!this.cardName) {
          this.errorDialog.message = "Nome impresso no cartão não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        if (this.possuiNumero(this.cardName)) {
          this.errorDialog.message = "Nome impresso no cartão não pode possuir números!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        if (!this.cpfTitular) {
          this.errorDialog.message = "CPF não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        if (!this.isValidCPF(this.cpfTitular)) {
          this.errorDialog.message = "CPF inválido, verifique!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        // Valida Mês de validadr
        if (!this.cardMonth) {
          this.errorDialog.message = "Mês de validade do cartão não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        // Valida Mês de validadr
        if (!this.cardYear) {
          this.errorDialog.message = "Ano de validade do cartão não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        // Valida código de segurança
        if (!this.cardCvv) {
          this.errorDialog.message = "CVV não preenchido!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        if (this.cardCvv.length < 3) {
          this.errorDialog.message = "CVV incorreto, verifique!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }

        // Valida se a quantidade de parcelas foi selecionada
        if (!this.parcelasSelecionada) {
          this.errorDialog.message = "Quantidade de parcelas não selecionado!";
          this.errorDialog.action = () => { this.errorDialog.active = false };
          this.errorDialog.active = true;
          return false;
        }
      }

      // Valida menor valor de transação (R$ 1,00)
      if (this.valorPagamento < 1) {
        this.errorDialog.message = "O valor de pagamento não pode ser menor que R$1,00!";
        this.errorDialog.action = () => { this.errorDialog.active = false };
        this.errorDialog.active = true;
        return false;
      }

      // Valida se o pagamento será menor que o frete - VALIDAR DEPOIS SE NÃO É O PRIMEIRO PAGAMENTO
      if ((this.ValorRestantePagamento === this.ValorTotalPedido) && this.valorPagamento < this.Pedido.vltotalfrete) {
        this.errorDialog.message = "O valor do primeiro pagamento não pode ser menor que o valor do frete!";
        this.errorDialog.action = () => { this.errorDialog.active = false };
        this.errorDialog.active = true;
        return false;
      }

      // Valida se o preço digitado é maior que o valor do produto
      if (this.valorPagamento > this.ValorTotalPedido) {
        this.errorDialog.message = "O valor de pagamento não pode ser maior que o valor do pedido!";
        this.errorDialog.action = () => { this.errorDialog.active = false };
        this.errorDialog.active = true;
        return false;
      }

      if ((this.ValorRestantePagamento < this.ValorTotalPedido) && this.valorPagamento > this.ValorRestantePagamento) {
        this.errorDialog.message = "O valor de pagamento não pode ser maior que o valor restante de pagamento do pedido!";
        this.errorDialog.action = () => { this.errorDialog.active = false };
        this.errorDialog.active = true;
        return false;
      }

      // Retorna true caso não possuir nenhum bloqueio
      return true;
    },

    isValidCPF(cpf) {
      if (typeof cpf !== "string") return false
      cpf = cpf.replace(/[\s.-]*/igm, '')
      if (
          !cpf ||
          cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999" 
      ) {
          return false
      }
      var soma = 0
      var resto
      for (let i = 1; i <= 9; i++) 
          soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
      resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(9, 10)) ) return false
      soma = 0
      for (let i = 1; i <= 10; i++) 
          soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
      resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(10, 11) ) ) return false
      return true
    },

    possuiNumero(palavra){
      const regex = /[0-9]/;
      return regex.test(palavra);
    },

    somenteNumeros(str) {
      let onlyNumbers = str.replace(/\D+/g, '');
      return onlyNumbers;
    },

    finalizaPagamento() {
      // Realiza validações do formulário
      if (!this.validacoes(false)) {
        return;
      }

      this.loading.message = "Enviando dados de pagamento. Aguarde...";
      this.loading.active = true;

      // Recupera FingerPrint (Yapay)
      let fingerprint = window.yapay.FingerPrint({ env: 'sandbox' }).getFingerPrint();

      // Limpa a string dos campos
      let cpfLimpo = this.somenteNumeros(this.cpfTitular);
      let numCartaoLimpo = this.somenteNumeros(this.cardNumber);

      // Recupera o número do pedido
      let nrPedido = this.Pedido.NRPedido.split("-");

      // Monta o body da request
      let data = {
        nr_pedido: nrPedido[1],
        cpf: cpfLimpo,
        ip: this.ip,
        fingerprint,
        payment_value: this.valorPagamento,
        payment: {
          card_number: numCartaoLimpo,
          card_expdate_month: this.cardMonth,
          card_expdate_year: this.cardYear,
          card_cvv: this.cardCvv,
          split: this.parcelasSelecionada,
          card_name: this.cardName,
          payment_method_id: this.codigoBandeiraYapay,
        }
      }

      axios({
        method: "post",
        url: `${this.baseURL}/newyapay?capturePayment=true`,
        data: data,
      }).then(res => {
        this.loading.active = false;
        let arrayRetorno = res.data;
        // Verifica o retorno
        if (arrayRetorno.idstatus == '00') {
          this.successDialog.message = arrayRetorno.mensagem;
          this.successDialog.active = true;

        } else if (arrayRetorno.idstatus == 'err') {
          this.errorDialog.message = "Erro na finalização - Transação não realizada! " + arrayRetorno.mensagem;
          this.errorDialog.action = () => { window.location.reload() };
          this.errorDialog.active = true;
          return;
        
        } else if (arrayRetorno.idstatus == 'errGeral') {
          let msg = "Erro na finalização - Transação não realizada. Entre em contato com o Vendedor!";
          msg += arrayRetorno.mensagem ? ' ' + arrayRetorno.mensagem : '';
          this.errorDialog.message = msg;
          this.errorDialog.action = () => { window.location.reload() };
          this.errorDialog.active = true;
          return;
        
        } else {
          if (arrayRetorno.mensagem === 'Transação em análise' && arrayRetorno.idstatus === '12321') {
            this.successDialog.message = arrayRetorno.mensagem;
            this.successDialog.active = true;
            return;
          } else {
            this.errorDialog.message = "Transação não realizada, verifique os dados do cartão! " + arrayRetorno.mensagem + '. Código: ' + arrayRetorno.idstatus;
            this.errorDialog.action = () => { window.location.reload() };
            this.errorDialog.active = true;
            return;
          }
        }
      }).catch(err => {
        let msg = "";
        if (err && err.response && err.response.data) {
          msg = err.response.data
        }
        this.errorDialog.message = "Erro ao finalizar pagamento! <br/>" + msg;
        this.errorDialog.action = () => { window.location.reload() };
        this.errorDialog.active = true;
        this.loading.active = false;
      }) 
    },
  }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");

body {
  // background: var(--standardGreen);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
}
* {
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
}

.wrapper {
  background-color: var(--standardGreen);
  min-height: 100vh;
  display: flex;
  padding: 50px 15px;
  flex-direction: column;
  @media screen and (max-width: 700px), (max-height: 500px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
}

.card-form {
  max-width: 570px;
  margin: auto;
  width: 100%;

  @media screen and (max-width: 576px) {
    margin: 0 auto;
  }

  &__inner {
    background: #fff;
    // box-shadow: 3px 13px 30px 0px rgba(21, 34, 67, 0.2);
    box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
    border-radius: 10px;
    padding: 35px;
    padding-top: 180px;

    @media screen and (max-width: 480px) {
      padding: 25px;
      padding-top: 165px;
    }
    @media screen and (max-width: 360px) {
      padding: 15px;
      padding-top: 165px;
    }
  }

  &__row {
    display: flex;
    align-items: flex-start;
    @media screen and (max-width: 480px) {
      flex-wrap: wrap;
    }
  }

  &__col {
    flex: auto;
    margin-right: 35px;

    &:last-child {
      margin-right: 0;
    }

    @media screen and (max-width: 480px) {
      margin-right: 0;
      flex: unset;
      width: 100%;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &.-cvv {
      max-width: 150px;
      @media screen and (max-width: 480px) {
        max-width: initial;
      }
    }
  }

  &__group {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .card-input__input {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 55px;
    background: var(--standardGreen);
    border: none;
    border-radius: 5px;
    font-size: 22px;
    font-weight: 500;
    font-family: "Source Sans Pro", sans-serif;
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      margin-top: 10px;
    }
  }
}

.card-item {
  max-width: 430px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;

  @media screen and (max-width: 480px) {
    max-width: 310px;
    height: 220px;
    width: 90%;
  }

  @media screen and (max-width: 360px) {
    height: 180px;
  }

  &.-active {
    .card-item__side {
      &.-front {
        transform: perspective(1000px) rotateY(180deg) rotateX(0deg)
          rotateZ(0deg);
      }
      &.-back {
        transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
        // box-shadow: 0 20px 50px 0 rgba(81, 88, 206, 0.65);
      }
    }
  }

  &__focus {
    position: absolute;
    z-index: 3;
    border-radius: 5px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.65);

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: rgb(8, 20, 47);
      height: 100%;
      border-radius: 5px;
      filter: blur(25px);
      opacity: 0.5;
    }

    &.-active {
      opacity: 1;
    }
  }

  &__side {
    border-radius: 15px;
    overflow: hidden;
    // box-shadow: 3px 13px 30px 0px rgba(11, 19, 41, 0.5);
    box-shadow: 0 20px 60px 0 rgba(14, 42, 90, 0.55);
    transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
    transform-style: preserve-3d;
    transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    backface-visibility: hidden;
    height: 100%;

    &.-back {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
      z-index: 2;
      padding: 0;
      // background-color: #2364d2;
      // background-image: linear-gradient(
      //   43deg,
      //   #4158d0 0%,
      //   #8555c7 46%,
      //   #2364d2 100%
      // );
      height: 100%;

      .card-item__cover {
        transform: rotateY(-180deg)
      }
    }
  }
  &__bg {
    max-width: 100%;
    display: block;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &__cover {
    height: 100%;
    background-color: #1c1d27;
    position: absolute;
    height: 100%;
    background-color: #1c1d27;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(6, 2, 29, 0.45);
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 40px;
    padding: 0 10px;

    @media screen and (max-width: 480px) {
      margin-bottom: 25px;
    }
    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }

  &__chip {
    width: 60px;
    @media screen and (max-width: 480px) {
      width: 50px;
    }
    @media screen and (max-width: 360px) {
      width: 40px;
    }
  }

  &__type {
    height: 45px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    max-width: 100px;
    margin-left: auto;
    width: 100%;

    @media screen and (max-width: 480px) {
      height: 40px;
      max-width: 90px;
    }
    @media screen and (max-width: 360px) {
      height: 30px;
    }
  }

  &__typeImg {
    max-width: 100%;
    object-fit: contain;
    max-height: 100%;
    object-position: top right;
  }

  &__info {
    color: #fff;
    width: 100%;
    max-width: calc(100% - 85px);
    padding: 10px 15px;
    font-weight: 500;
    display: block;

    cursor: pointer;

    @media screen and (max-width: 480px) {
      padding: 10px;
    }
  }

  &__holder {
    opacity: 0.7;
    font-size: 13px;
    margin-bottom: 6px;
    @media screen and (max-width: 480px) {
      font-size: 12px;
      margin-bottom: 5px;
    }
  }

  &__wrapper {
    font-family: "Source Code Pro", monospace;
    padding: 25px 15px;
    position: relative;
    z-index: 4;
    height: 100%;
    text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
    user-select: none;
    @media screen and (max-width: 480px) {
      padding: 20px 10px;
    }
  }

  &__name {
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__nameItem {
    display: inline-block;
    min-width: 8px;
    position: relative;
  }

  &__number {
    font-weight: 500;
    line-height: 1;
    color: #fff;
    font-size: 27px;
    margin-bottom: 35px;
    display: inline-block;
    padding: 10px 15px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 21px;
      margin-bottom: 15px;
      padding: 10px 10px;
    }

    @media screen and (max-width: 360px) {
      font-size: 19px;
      margin-bottom: 10px;
      padding: 10px 10px;
    }
  }

  &__numberItem {
    width: 16px;
    display: inline-block;
    &.-active {
      width: 30px;
    }

    @media screen and (max-width: 480px) {
      width: 13px;

      &.-active {
        width: 16px;
      }
    }

    @media screen and (max-width: 360px) {
      width: 12px;

      &.-active {
        width: 8px;
      }
    }
  }

  &__content {
    color: #fff;
    display: flex;
    align-items: flex-start;
  }

  &__date {
    flex-wrap: wrap;
    font-size: 18px;
    margin-left: auto;
    padding: 10px;
    display: inline-flex;
    width: 80px;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }

  &__dateItem {
    position: relative;
    span {
      width: 22px;
      display: inline-block;
    }
  }

  &__dateTitle {
    opacity: 0.7;
    font-size: 13px;
    padding-bottom: 6px;
    width: 100%;

    @media screen and (max-width: 480px) {
      font-size: 12px;
      padding-bottom: 5px;
    }
  }
  &__band {
    background: rgba(0, 0, 19, 0.8);
    width: 100%;
    height: 50px;
    margin-top: 30px;
    position: relative;
    z-index: 2;
    @media screen and (max-width: 480px) {
      margin-top: 20px;
    }
    @media screen and (max-width: 360px) {
      height: 40px;
      margin-top: 10px;
    }
  }

  &__cvv {
    text-align: right;
    position: relative;
    z-index: 2;
    padding: 15px;
    .card-item__type {
      opacity: 0.7;
    }

    @media screen and (max-width: 360px) {
      padding: 10px 15px;
    }
  }
  &__cvvTitle {
    padding-right: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }
  &__cvvBand {
    height: 45px;
    background: #fff;
    margin-bottom: 30px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    color: #1a3b5d;
    font-size: 18px;
    border-radius: 4px;
    box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);

    @media screen and (max-width: 480px) {
      height: 40px;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }
}

.card-list {
  margin-bottom: -130px;

  @media screen and (max-width: 480px) {
    margin-bottom: -120px;
  }
}

.card-input {
  margin-bottom: 20px;
  &__label {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
    color: #1a3b5d;
    width: 100%;
    display: block;
    user-select: none;
  }
  &__input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    box-shadow: none;
    border: 1px solid #ced6e0;
    transition: all 0.3s ease-in-out;
    font-size: 18px;
    padding: 5px 15px;
    background: none;
    color: #1a3b5d;
    font-family: "Source Sans Pro", sans-serif;

    &:hover,
    &:focus {
      border-color: #3d9cff;
    }

    &:focus {
      box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
    }
    &.-select {
      -webkit-appearance: none;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC');
      background-size: 12px;
      background-position: 90% center;
      background-repeat: no-repeat;
      padding-right: 30px;
    }
  }
}

.slide-fade-up-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}
.slide-fade-up-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}
.slide-fade-up-enter {
  opacity: 0;
  transform: translateY(15px);
  pointer-events: none;
}
.slide-fade-up-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  pointer-events: none;
}

.slide-fade-right-enter-active {
  transition: all 0.25s ease-in-out;
  transition-delay: 0.1s;
  position: relative;
}
.slide-fade-right-leave-active {
  transition: all 0.25s ease-in-out;
  position: absolute;
}
.slide-fade-right-enter {
  opacity: 0;
  transform: translateX(10px) rotate(45deg);
  pointer-events: none;
}
.slide-fade-right-leave-to {
  opacity: 0;
  transform: translateX(-10px) rotate(45deg);
  pointer-events: none;
}



.github-btn {
  position: absolute;
  right: 40px;
  bottom: 50px;
  text-decoration: none;
  padding: 15px 25px;
  border-radius: 4px;
  box-shadow: 0px 4px 30px -6px rgba(36, 52, 70, 0.65);
  background: #24292e;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 16px;
  text-align: center;
  transition: all .3s ease-in-out;

  @media screen and (min-width: 500px) {
    &:hover {
      transform: scale(1.1);
      box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
    }
  }

  @media screen and (max-width: 700px) {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 20px;

    &:active {
      transform: scale(1.1);
      box-shadow: 0px 17px 20px -6px rgba(36, 52, 70, 0.36);
    }
  }
}

.order {
  font-family: "Source Sans Pro", sans-serif;

  @media (min-width: 769px) {
    width: 100%;
  }

  h2 {
    font-size: 1.2rem;
  }

  .item {
    display: flex;
    align-items: center;
    padding: 10px 0;
    flex-direction: column;

    @media (min-width: 441px) {
      flex-direction: row;
    }

    &__description {
      margin-left: 20px;

      p {
        font-weight: 700;
        color: var(--customGray-800);

        span {
          font-weight: 500;
        }
      }
    }
  }

  .footer {
    margin-top: 30px;
    display: flex;

    .address,
    .totals {
      flex: 1;

      h3 {
        margin-bottom: 15px;
        font-size: 1rem;
        color: var(--standardGreen);
      }

      &__item {
        h4 {
          color: var(--customDarkGreen);
          padding-bottom: 10px;
        }

        p {
          font: 500 0.85rem/1.6 "Soleto", sans-serif;
          color: var(--customGray-800);
        }
      }
    }
  }
}

</style>